import PricelistProductSalesChannelTable from "@/features/pricelist-product-sales-channel/components/PricelistProductSalesChannelTable";
import type { PricelistProduct } from "@/generated/graphql";
import { SectionBuilder } from "@k3-tech/react-kit";

export default function PricelistProductDetailTemplate({
  data,
}: {
  data: PricelistProduct,
}) {
  return (
    <SectionBuilder
      sections={[
        {
          id: "detail",
          variant: "plain",
          layout: "grid",
          className: "border-gray-200",
          grid: { cols: 1, mdCols: 2, gap: "gap-4" },
          children: [
            {
              key: "productName",
              label: "Product",
              labelLayout: "stacked",
              content: `${data.product?.productCode} - ${data.product?.productName}`,
            },
            {
              key: "sellingPrice",
              label: "Selling Price",
              labelLayout: "stacked",
              content: data.sellingPrice,
            }
          ]
        },
        {
          id: "salesChannelTable",
          layout: "grid",
          variant: "plain",
          className: "border-gray-200",
          grid: { cols: 1, gap: "gap-4" },
          children: [
            {
              key: "salesChannelTable",
              label: "",
              labelClassName: "hidden",
              content: (
                <PricelistProductSalesChannelTable
                  pricelistProductID={data.pricelistProductID}
                />
              )
            }
          ]
        }
      ]}
    />
  );
}
